import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/verify-email')({
  component: VerifyEmailPage,
})

function VerifyEmailPage() {
  return <h1>Verify Email — coming soon</h1>
}
